import LoadingModal from '@components/atoms/modals/LoadingModal';
import { AnalyticsScreenName } from 'mh-client';
import { lazy, Suspense } from 'react';
import { Route } from 'react-router';
import ProtectedRoute from './components/ProtectedRoute';

const Names = AnalyticsScreenName.getInstance();

const ShareReservationFeedbackPage = lazy(
    () => import('@pages/feedback/ShareReservationFeedbackPage')
);
const ShareCancelledFeedbackPage = lazy(
    () => import('@pages/feedback/ShareCancelledFeedbackPage')
);

export const FeedbackRoutes = (
    <>
        <Route
            path="/funds/investment/buy/feedback"
            handle={{ screen_name: Names.SHARE_RESERVED_FEEDBACK }}
            element={
                <ProtectedRoute
                    accountStatus={['Complete']}
                    outlet={
                        <Suspense fallback={<LoadingModal />}>
                            <ShareReservationFeedbackPage />
                        </Suspense>
                    }
                />
            }
        />
        <Route
            path="/funds/investment/cancelled/feedback"
            handle={{ screen_name: Names.SHARE_CANCELLED_FEEDBACK }}
            element={
                <ProtectedRoute
                    accountStatus={['Complete']}
                    outlet={
                        <Suspense fallback={<LoadingModal />}>
                            <ShareCancelledFeedbackPage />
                        </Suspense>
                    }
                />
            }
        />
    </>
);
